<template>
  <v-row>
    <v-col cols="12" sm="5">
      <v-card tile class="mb-4">
        <v-card-text class="px-6 py-6">
      <v-dialog
        ref="dialog"
        v-model="timeModal"
        :return-value.sync="formData.dayStart"
        persistent
        width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="formData.dayStart"
            :label="dictionary.attributes.dayStart"
            prepend-icon="mdi-clock-outline"
            readonly
            v-on="on"
          ></v-text-field>
        </template>
        <v-time-picker
          v-if="timeModal"
          v-model="formData.dayStart"
          full-width
          scrollable
        >
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="timeModal = false">Cancel</v-btn>
          <v-btn text color="primary" @click="$refs.dialog.save(formData.dayStart)">OK</v-btn>
        </v-time-picker>
      </v-dialog>
        </v-card-text>
      </v-card>
      <v-card tile>
        <v-card-text class="px-6 py-6">
          <budget-planner-form @save="onAdd"></budget-planner-form>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="12" sm="7">
      <v-card tile class="px-4 py-4">
        <v-card-text>
          <h4 class="subtitle text--primary">Daily schedule</h4>
        </v-card-text>
        <draggable
          class="list-group"
          v-model="list"
          v-bind="dragOptions"
          :move="onMove"
          @start="isDragging = true"
          @end="isDragging = false"
        >
          <transition-group type="transition" :name="'flip-list'">
            <div class="cursor-move" v-for="(task, index) in taskList" :key="task.order">
              <v-divider v-if="index!==0"></v-divider>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    <div class="text-capitalize">{{ task.name }}</div>
                    <div class="caption">Hours: {{ task.order }}</div>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </div>
          </transition-group>
        </draggable>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import draggable from 'vuedraggable';
import BudgetPlannerForm from '@/components/BudgetPlannerForm.vue';

const message = [
  'vue.draggable',
  'draggable',
  'component',
  'for',
  'vue.js 2.0',
  'based',
  'on',
  'Sortablejs',
];

export default {
  name: 'budget-planner-tool',
  components: {
    draggable,
    BudgetPlannerForm,
  },
  data() {
    return {
      timeModal: false,
      formData: {},
      dictionary: {
        attributes: {
          dayStart: 'Day starts at',
        },
      },
      taskList: message.map((name, index) => ({
        name,
        order: index + 1,
        fixed: false,
      })),
      editable: true,
      isDragging: false,
      delayedDragging: false,
    };
  },
  methods: {
    orderList() {
      this.taskList = this.taskList.sort((one, two) => one.order - two.order);
    },
    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      );
    },
    onAdd() {},
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: 'description',
        disabled: !this.editable,
        ghostClass: 'ghost',
      };
    },
    taskListString() {
      return JSON.stringify(this.taskList, null, 2);
    },
  },
  watch: {
    isDragging(newValue) {
      if (newValue) {
        this.delayedDragging = true;
        return;
      }
      this.$nextTick(() => {
        this.delayedDragging = false;
      });
    },
  },
};
</script>

<style scoped>
.list-group {
  min-height: 20px;
}

.v-list-item {
  cursor: move;
}
</style>
<style>
.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.sortable-chosen {
  opacity: 0.8;
  outline: 2px solid #cfe0ff;
}

.ghost {
  opacity: 0.5;
  background: #cfe0ff;
  outline: 2px solid #afcbff;
}

.cursor-move {
  cursor: move;
}
</style>
